// extracted by mini-css-extract-plugin
export default {"scan":"style_scan__0jndU"};